import {BASE_URL, MEDIA_URL} from '../shared/constants';
import {TranslatableString} from './TranslatableString';

export class User {
  name: TranslatableString;
  phoneNumber: string;
  mobileNumber: string;
  email: string;
  
  picture: string;
  user_picture?: string;
  workPosition: TranslatableString;
  
  birthdate: string;
  education: TranslatableString;
  spokenLanguages: TranslatableString;
  
  additionalQualifications: TranslatableString;
  workingFrom: string;
  interests: TranslatableString;
  
  constructor(user: any) {
    this.name = new TranslatableString(user.name, user.name_en, user.name_bg, user.name_ru);
    this.phoneNumber = user.phone_number;
    this.mobileNumber = user.mobile_number;
    this.email = user.email;
    this.picture = MEDIA_URL + user.user_picture;
    
    this.workPosition = new TranslatableString(user.work_position, user.work_position_en, user.work_position_bg, user.work_position_ru);
    this.birthdate = user.birth_date;
    this.education = new TranslatableString(user.education, user.education_en, user.education_bg, user.education_ru);
    this.spokenLanguages = new TranslatableString(
      user.spoken_languages,
      user.spoken_languages_en,
      user.spoken_languages_bg,
      user.spoken_languages_ru);
    this.additionalQualifications = new TranslatableString(
      user.additional_qualification,
      user.additional_qualification_en,
      user.additional_qualification_bg,
      user.additional_qualification_ru);
    this.workingFrom = user.working_from_date;
    this.interests = new TranslatableString(user.interests, user.interests_en, user.interests_bg, user.interests_ru);
  }
}
